import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Box, Button, List, ListItem, ListItemText, Typography } from '@mui/material';
import { map } from 'lodash';
import React from 'react';

import { UnconfiguredAnnotationValue } from './annotationClassOptions';

interface UnconfiguredAnnotationValuesProps {
  values: UnconfiguredAnnotationValue[];
  onAdd: (value: UnconfiguredAnnotationValue) => void;
}

const getCountLabel = ({ savedCount, draftCount }: UnconfiguredAnnotationValue) => {
  if (savedCount === draftCount) {
    return `${savedCount} saved and draft annotations`;
  }
  return `${savedCount} saved · ${draftCount} draft annotations`;
};

const UnconfiguredAnnotationValues: React.FC<UnconfiguredAnnotationValuesProps> = ({ values, onAdd }) => (
  <Box>
    <Typography variant="subtitle2">{`Unconfigured annotation values (${values.length})`}</Typography>
    <List disablePadding>
      {map(values, (value) => (
        <ListItem
          key={value.nameKey}
          disableGutters
          secondaryAction={
            <Button size="small" startIcon={<AddCircleOutlineIcon />} onClick={() => onAdd(value)}>
              Add to active classes
            </Button>
          }
        >
          <ListItemText primary={value.label} secondary={getCountLabel(value)} />
        </ListItem>
      ))}
    </List>
  </Box>
);

export default UnconfiguredAnnotationValues;
